import Reflux from 'reflux'
import Proxies from 'Components/proxies'
const { GET, POST } = Proxies
import keyMirror from 'keymirror'
import 'moment/locale/da'

export const STATUS = keyMirror({
  IS_FETCHING: null,
  FETCHING_ERROR: null,
  UPDATE_SUCCESS: null,
  UPDATE_ERROR: null,
  DELETE_ERROR: null,
  DELETE_SUCCESS: null,
  TAKING_INPUT: null,
  IS_SAVING: null,
  REDIRECT: null
})

export const StockLocationActions = Reflux.createActions([
  'getStockLocations',
  'deleteStockLocation',
  'clearToast',
  'createEmptyStockLocation',
  'clearFormToast',
  'updateStockLocationField',
  'saveStockLocation',
  'getStockLocationDetails'
])

export class StockLocationStore extends Reflux.Store {
  constructor(props) {
    super(props)
    this.listenables = StockLocationActions
    this.state = {
      status: null,
      stockLocations: [],
      stockLocationName: null,
      stockLocationDetails: {
        name: '',
        removed: false
      }
    }
  }

  getStockLocations() {
    if (this.state.status === STATUS.IS_FETCHING) {
      return
    }

    this.setState({ status: STATUS.IS_FETCHING })
    GET('stockLocations/pool').then(responseJSON => {
      let nextState = {
        stockLocations: []
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATUS.FETCHING_ERROR
        } else {
          nextState.stockLocations = responseJSON
          nextState.status = null
        }
      }
      this.setState(nextState)
    })
  }

  clearToast() {
    this.setState({ status: null })
  }

  deleteStockLocation(id = null) {
    if (id) {
      POST('stockLocations/removeStockLocation', { StockLocationID: id }).then(responseJSON => {
        if (responseJSON.error) {
          this.setState({ status: STATUS.DELETE_ERROR })
        } else {
          this.getStockLocations()
        }
      })
    }
  }

  createEmptyStockLocation() {
    this.setState({
      stockLocationDetails: {
        name: '',
        removed: false
      }
    })
  }

  clearFormToast(status) {
    status ? this.setState({ status }) : this.setState({ status: STATUS.TAKING_INPUT })
  }

  getStockLocationDetails(id = null) {
    if (!id) {
      return
    }

    this.setState({ status: STATUS.IS_FETCHING })
    GET('stockLocations/fetch', { StockLocationID: id }).then(responseJSON => {
      let nextState = {
        stockLocationDetails: {}
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATUS.FETCHING_ERROR
        } else {
          nextState.stockLocationDetails = responseJSON
          nextState.status = STATUS.TAKING_INPUT
        }
      }
      this.setState(nextState)
    })
  }

  updateStockLocationField(field) {
    let fieldName = field.target.name
    let fieldValue
    if (fieldName === 'removed') {
      fieldValue = field.target.checked ? 1 : 0
    } else {
      fieldValue = field.target.value
    }
    let stockLocationDetails = this.state.stockLocationDetails
    stockLocationDetails[fieldName] = fieldValue
    this.setState({ stockLocationDetails })
  }

  saveStockLocation() {
    let stockLocationDetails = this.state.stockLocationDetails
    this.setState({ status: STATUS.IS_SAVING })
    POST('stockLocations/replace', stockLocationDetails).then(responseJSON => {
      if (responseJSON) {
        if (responseJSON.error) {
          this.setState({ status: STATUS.UPDATE_ERROR })
        } else {
          this.setState({ status: STATUS.UPDATE_SUCCESS })
        }
      }
    })
  }
}
